/**
 * Starts a provider sign-in from React.
 *
 * OmniAuth 2 rejects GET on the request phase (CVE-2015-9284), so
 * `window.location.href = '/participants/auth/github'` no longer works — it
 * answers "Not found. Authentication passthru." It has to be a POST carrying
 * the Rails CSRF token, which is what omniauth-rails_csrf_protection verifies;
 * a POST without the token is bounced to `/`.
 *
 * ERB templates get this for free from `link_to ..., method: :post`, which
 * rails-ujs turns into exactly the form below. React components have no
 * rails-ujs behaviour attached to the element, so they build it here.
 *
 * The CSRF token comes from the `csrf_meta_tags` in application.html.erb, which
 * is the layout every page rendering these buttons uses — so the empty-token
 * branch is unreachable in the app, and exists only so this is testable.
 */
export function startOmniauth(provider: string): void {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = `/participants/auth/${provider}`;

  const csrfMeta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
  const csrf = (csrfMeta && csrfMeta.content) || '';
  if (csrf) {
    const tokenField = document.createElement('input');
    tokenField.type = 'hidden';
    tokenField.name = 'authenticity_token';
    tokenField.value = csrf;
    form.appendChild(tokenField);
  }

  // Firefox and Safari refuse to submit a form that is not in the document.
  document.body.appendChild(form);
  form.submit();
}

export default startOmniauth;
